<template>
  <div class="contain">
    <el-form
      :model="inputForm"
      :label-width="$device.mobile ? `` : `120px`"
      label-suffix=":"
      :size="size"
      @submit.native.prevent>
      <el-row>
        <el-col :md="10">
          <el-form-item :label="$t('아이디')">
            <span class="show_cd">{{ inputForm.accountId }}</span>
          </el-form-item>
        </el-col>
        <el-col :md="10">
          <el-form-item :label="$t('사용자명')" :error="formError.accountNm" required>
            <el-input v-model="inputForm.accountNm" maxlength="50" clearable show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 「비밀번호를 안 바꾼다」는 **빈칸**이다 — 서버가 준 해시를 되돌려 보내지 않는다(보안 원장 ⑥).
           이 화면은 언제나 수정이므로 필수가 아니고, 대신 빈칸의 뜻을 한 줄로 말한다 -->
      <el-row>
        <el-col :md="10">
          <el-form-item :label="$t('비밀번호')" :error="formError.accountPw">
            <el-input v-model="inputForm.accountPw" maxlength="20" type="password" clearable></el-input>
            <div class="account-password-hint">{{ passwordText.keepHint }}</div>
          </el-form-item>
        </el-col>
        <el-col :md="10">
          <el-form-item :label="$t('비밀번호 확인')" :error="formError.accountPwConfirm">
            <el-input v-model="inputForm.accountPwConfirm" maxlength="20" type="password" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="10">
          <el-form-item :label="$t('핸드폰 번호')" :error="formError.tel" required>
            <el-input
              v-keep-number-caret
              :value="util.telFieldText(inputForm.tel)"
              maxlength="20"
              clearable
              show-word-limit
              @input="inputForm.tel = util.telDigits($event)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="10">
          <el-form-item :label="$t('이메일')" :error="formError.email" required>
            <el-input v-model="inputForm.email" maxlength="100" clearable show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="save" icon="el-icon-check" :size="size" :disabled="btn.saveDisabled">{{
        $t('저장')
      }}</el-button>
    </div>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import { PASSWORD_TEXT, blankPassword, passwordPatch } from '@/utils/accountPassword'
import { initData } from '@/utils/constants'

export default {
  name: 'EditAccount',

  mixins: [mainVueMixin],

  props: {
    type: {
      type: String,
      validator(value) {
        return ['store', 'cust'].includes(value)
      },
    },
  },

  data: function () {
    var data = initData()

    if (this.type == 'store') {
      data.url = '/user/info/store'
    } else if (this.type == 'cust') {
      data.url = '/user/info/cust'
    }

    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()
    /** 비밀번호 축의 문구 — 판정과 같은 파일이 소유한다(`utils/accountPassword`) */
    data.passwordText = PASSWORD_TEXT

    data.dialogFormVisible = true
    data.btn.saveDisabled = false

    return data
  },
  created: function () {
    this.up()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'U',
        title: this.$t('정보 수정'),
        accountId: '',
        accountNm: '',
        accountPw: '',
        accountPwConfirm: '',
        tel: '',
        email: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        accountNm: '',
        accountPw: '',
        accountPwConfirm: '',
        tel: '',
        email: '',
      }
    },
    /**
     * 내 정보 조회 — 응답을 통째로 폼에 담아 저장이 그대로 되돌려 보낸다.
     *
     * **비밀번호만 예외다**: 두 칸은 언제나 빈칸으로 연다([blankPassword]). 서버는 더 이상 해시를
     * 내리지 않고(보안 원장 ⑥), 빈칸은 「그대로 둔다」는 뜻이다([passwordPatch]).
     */
    up: function () {
      this.mainVue.$axios.search(
        this.url,
        null,
        function (result) {
          this.inputForm = Object.assign({}, result, blankPassword())
        }.bind(this),
        false
      )

      this.formError = this.initFormError()
    },
    /** 저장 — 비밀번호 축의 판정은 [passwordPatch] 한 곳이고, 나머지 필드는 읽은 그대로 되돌아간다 */
    save: function () {
      this.formError = this.initFormError()

      const patch = passwordPatch(this.inputForm)

      if (!patch.ok) {
        this.formError[patch.field] = this.$t(patch.message)

        return
      }

      this.mainVue.$axios.up(
        this.url + '/' + this.inputForm.accountId,
        patch.payload,
        this.formError,
        function (result) {
          this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
        }.bind(this),
        true
      )
    },
  },
}
</script>

<style scoped>
.el-dialog__header {
  padding: 0 !important;
}
</style>
